<template>
    <div>
        Engine Fault Detail
    </div>
</template>

<script>
    export default {
        name: "EngineFaultDetail"
    }
</script>

<style scoped>

</style>
